import { MeasurableGroupType } from '@upright/common/model/input/measurable-group/types';
import { ModelEntityType } from '@upright/common/model/input/types';
import { BouColor } from '@upright/ui/common/generic/global/bou-colors';
import { EmptyStateExampleCompanyProfilesCTA } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/empty-states/ctas/empty-state-example-company-profiles-cta';
import { EmptyStateStartManagingCTA } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/empty-states/ctas/start-managing';
import { EmptyInfoBox } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/empty-states/empty-info-box';
import { WishToLearnMore } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/empty-states/ctas/wish-to-learn-more-cta';
import { useCarouselContext } from '@upright/ui/common/upright/core/impact-lens-profile/context';
import { SingleEntityLensData } from '@upright/ui/common/upright/core/impact-lens-profile/types';
import styled from 'styled-components';

interface Props {
  dataTitle?: string;
  message?: string; // TODO: maybe turn to function of entity, so that company name can be included in message
}

export function EmptyStateNoData(props: Props) {
  const context = useCarouselContext();
  const data = context.data as SingleEntityLensData<any>;

  function getEntityTitle() {
    if (data.groupType === MeasurableGroupType.FUND) {
      return 'fund';
    }
    if (data.groupType === MeasurableGroupType.INDEX) {
      return 'index';
    }
    if (data.entity?.type === ModelEntityType.COMPANY) {
      return 'company';
    }
    if (data.entity?.type === ModelEntityType.PRODUCT) {
      return 'product';
    }
    return 'item';
  }

  function getMessage() {
    if (props.message) {
      return <>{props.message}</>;
    }
    if (props.dataTitle) {
      return (
        <>
          No {props.dataTitle} is currently available for this {getEntityTitle()}.
        </>
      );
    }
    return <>This data is currently not available for this {getEntityTitle()}.</>;
  }

  const isCompany = data.entity?.type === ModelEntityType.COMPANY;
  const companyId = isCompany ? data.entity?.id : undefined;

  return (
    <EmptyInfoBox title="No data available" topColor={BouColor.IMPACT_NEGATIVE_PURPLE}>
      <>
        <Text>{getMessage()}</Text>
        {isCompany && companyId && <WishToLearnMore companyId={companyId} />}
        <EmptyStateStartManagingCTA />
        {/* Example company profiles answer "what does this data look like" for a company, not a product. */}
        {data.entity?.type !== ModelEntityType.PRODUCT && <EmptyStateExampleCompanyProfilesCTA />}
      </>
    </EmptyInfoBox>
  );
}

const Text = styled.div``;
